import * as React from 'react';
import {
  StyleSheet,
  Pressable,
  ImageSourcePropType,
  Image,
  View,
  ScrollView
} from 'react-native';
import { translate } from 'secullum-i18n';
import {
  Card,
  DetailsHeader,
  getTestID,
  getTheme,
  isTablet,
  Space,
  Text
} from 'secullum-react-native-ui';
import Link from '../../components/Link';
import { montarRespostas } from '../../modules/qualidadeVidaTrabalho';
import {
  QualidadeVidaTrabalho,
  TipoRespostaQualidadeVidaTrabalho
} from '../../modules/types';

interface QualidadeVidaTrabalhoOpcoesProps {
  dados: QualidadeVidaTrabalho;
  onConcluir: (resposta: TipoRespostaQualidadeVidaTrabalho) => void;
}

interface QualidadeVidaTrabalhoOpcaoProps {
  text: string;
  image: ImageSourcePropType;
  nativeID: string;
  onPress: () => void;
}

function QualidadeVidaTrabalhoOpcao({
  text,
  image,
  nativeID,
  onPress
}: QualidadeVidaTrabalhoOpcaoProps) {
  return (
    <Card>
      <Pressable
        nativeID={nativeID}
        testID={getTestID(nativeID)}
        onPress={onPress}
        style={({ pressed }) => [{ opacity: pressed ? 0.7 : 1 }]}
      >
        <Card.Section style={styles.opcaoContainer}>
          <Image style={styles.opcaoImagem} source={image} />
          <Text style={styles.opcaoText}>{text}</Text>
        </Card.Section>
      </Pressable>
    </Card>
  );
}

class QualidadeVidaTrabalhoOpcoes extends React.Component<QualidadeVidaTrabalhoOpcoesProps> {
  render() {
    const { dados, onConcluir } = this.props;

    return (
      <View style={styles.container}>
        <ScrollView contentContainerStyle={styles.conteudo}>
          <DetailsHeader text={dados.pergunta} />
          <Space />
          <View style={styles.opcoes}>
            {montarRespostas(dados).map(resposta => (
              <QualidadeVidaTrabalhoOpcao
                key={resposta.sufixoId}
                nativeID={`qvt-resposta-${resposta.sufixoId}`}
                text={resposta.texto}
                image={resposta.imagem}
                onPress={() => onConcluir(resposta.tipo)}
              />
            ))}
          </View>
          <Space />
          <Link
            nativeID="qvt-nao-responder"
            style={styles.linkText}
            text={translate('Não responder')}
            onPress={() =>
              onConcluir(TipoRespostaQualidadeVidaTrabalho.NaoRespondeu)
            }
          />
        </ScrollView>
      </View>
    );
  }
}

const theme = getTheme();
const containerPadding = isTablet() ? 25 : 16;

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.backgroundColor1,
    borderRadius: 6,
    width: '100%',
    height: '100%'
  },
  conteudo: {
    padding: containerPadding
  },
  linkText: {
    fontSize: 20,
    textDecorationLine: 'underline',
    textAlign: 'center'
  },
  opcoes: {
    gap: 16
  },
  opcaoContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: 5
  },
  opcaoText: {
    fontFamily: theme.fontFamily1,
    fontSize: isTablet() ? 22 : 18,
    color: theme.textColor1,
    width: '80%',
    paddingLeft: 20,
    textAlign: 'left'
  },
  opcaoImagem: {
    width: 60,
    height: 60,
    marginLeft: 20
  }
});

export default QualidadeVidaTrabalhoOpcoes;
